import { type QuizFlowQuestion } from './QuestionBlock/QuestionBlock';

export const QUIZ_FLOW_QUESTIONS: QuizFlowQuestion[] = [
  {
    text: 'Are you confident in accurately reporting cryptocurrency earnings on your tax returns?',
    answers: [
      `Yes, I'm confident`,
      `No, It's challenging`,
      `I use an accountant`,
      `I haven't reported crypto earnings yet`,
    ],
  },
  {
    text: 'Does it take you a lot of time to organize crypto transactions for taxes?',
    answers: [`Yes, It's time consuming`, `No, It's quick`, `Haven't done it`],
    skippable: true,
  },
  {
    text: 'How much time do you currently spend filing taxes for your cryptocurrency investments?',
    answers: [
      `Several hours per month`,
      `An hour or two per month`,
      `I hire an accountant to do that for me`,
      `I haven't filed taxes for my crypto assets yet`,
    ],
    skippable: true,
  },
  {
    text: 'Do tax regulations for crypto investments overwhelm you?',
    answers: [
      `Yes, they do`,
      `No, I understand them`,
      `Haven't looked into it`,
    ],
    skippable: true,
  },
  {
    text: 'Do you struggle with accuracy when compiling tax reports for crypto investments?',
    answers: [
      `Yes, It's a challenge`,
      `No, It's accurate`,
      `Haven't faced any issues`,
    ],
    skippable: true,
  },
];
